import app from '../../app/app';

app.directive('onEvent', require('./onEvent.js'));
app.directive('compile', require('./compile.js').default);
